import { TFunction } from 'i18next';
import { SurveyQuestionType } from 'types/Survey';

export const getQuestionTypeOptions = (t: TFunction) => ({
	[SurveyQuestionType.INFO]: t('programPanel.feedback.questionTypeOption.info'),
	[SurveyQuestionType.TEXT]: t('programPanel.feedback.questionTypeOption.text'),
	[SurveyQuestionType.LONGTEXT]: t('programPanel.feedback.questionTypeOption.longtext'),
	[SurveyQuestionType.SCALE]: t('programPanel.feedback.questionTypeOption.scale'),
	[SurveyQuestionType.BOOLEAN]: t('programPanel.feedback.questionTypeOption.boolean'),
	[SurveyQuestionType.SINGLE_CHOICE]: t('programPanel.feedback.questionTypeOption.singleChoice'),
	[SurveyQuestionType.MULTI_CHOICE]: t('programPanel.feedback.questionTypeOption.multiChoice'),
});
